import React, { Component } from 'react'
import { connect } from "react-redux"
import { withStyles } from '@material-ui/core/styles';
import HomePage from '../Pages/Home/HomePage'
import VisitPage from '../Pages/Visit/VisitPage'

const styles = (theme) => {
    return ({
        // button: {
        //     width: buttonRadius * 2 + 'px',
        //     height: buttonRadius * 2 + 'px',
        //     backgroundColor: 'rgba(0,0,0,0.25)',
        //     borderRadius: buttonRadius + 'px',
        //     cursor: 'pointer'
        // },
        // buttonText: {
        //     marginTop: '50%',
        //     /* position: relative; */
        //     display: 'inline-block',
        //     transform: 'translate(0, -55%)',
        //     color: 'white',
        //     fontSize: buttonRadius + 'px'
        // }
    })
};

class PageSwitcher extends Component {
    render() {

        let component

        switch (this.props.activePageComponent) {
            case 'visit-list':
                component = <HomePage />    
                break;
            case 'visit':
                component = <VisitPage />    
                break;
        
            default:
                break;
        }

        return (
            component
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activePageComponent: state.app.global.activePageComponent
    }
};

export default connect(mapStateToProps, null)(withStyles(styles)(PageSwitcher));